module.exports = __webpack_public_path__ + "img/sn.a7e9a05e.svg";